import { useQuery } from "@tanstack/react-query";

import { api, unwrap } from "./client";

export const metaQueryKey = ["meta"] as const;

/** Server version and time; also used as a connectivity check. */
export function useMeta() {
  return useQuery({
    queryKey: metaQueryKey,
    queryFn: async ({ signal }) => unwrap(await api.GET("/api/v1/meta", { signal })),
    refetchInterval: 30_000,
    retry: 1,
  });
}
